import { UtilService } from "../helpers/util-service";
import { LoggingService } from "../helpers/logging-service";
export class DynamoManageTable {
    constructor({ dynamoDb, secondaryIndexOptions, tableFullName, partitionKeyFieldName, sortKeyFieldName, }) {
        Object.defineProperty(this, "partitionKeyFieldName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sortKeyFieldName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dynamoDb", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tableFullName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "secondaryIndexOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.dynamoDb = dynamoDb;
        this.tableFullName = tableFullName;
        this.partitionKeyFieldName = partitionKeyFieldName;
        this.sortKeyFieldName = sortKeyFieldName;
        this.secondaryIndexOptions = secondaryIndexOptions;
    }
    _tbl_getLocalVariables() {
        return {
            partitionKeyFieldName: this.partitionKeyFieldName,
            sortKeyFieldName: this.sortKeyFieldName,
            tableFullName: this.tableFullName,
            secondaryIndexOptions: this.secondaryIndexOptions,
        };
    }
    _tbl_dynamoDb() {
        return this.dynamoDb();
    }
    async fuse_tbl_getListOfTablesNamesOnline() {
        const params = {
            Limit: 99,
        };
        const listOfTables = await this._tbl_dynamoDb().listTables(params);
        return listOfTables?.TableNames;
    }
    async fuse_tbl_tableSettingUpdateTTL({ attrName, isEnabled }) {
        const { tableFullName } = this._tbl_getLocalVariables();
        const params = {
            TableName: tableFullName,
            TimeToLiveSpecification: {
                AttributeName: attrName,
                Enabled: isEnabled,
            },
        };
        const result = await this._tbl_dynamoDb().updateTimeToLive(params);
        if (result?.TimeToLiveSpecification) {
            return result.TimeToLiveSpecification;
        }
        return null;
    }
    async fuse_tbl_getTableInfo() {
        try {
            const { tableFullName } = this._tbl_getLocalVariables();
            const params = {
                TableName: tableFullName,
            };
            const result = await this._tbl_dynamoDb().describeTable(params);
            if (result?.Table?.TableName === tableFullName) {
                return result.Table;
            }
            return null;
        }
        catch (error) {
            LoggingService.log({ "@allGetTableInfoBase": "", error: error?.message });
            return null;
        }
    }
    async fuse_tbl_checkTableExists() {
        const result = await this.fuse_tbl_getTableInfo();
        if (!result) {
            return false;
        }
        if (result?.GlobalSecondaryIndexes) {
        }
        return true;
    }
    async _allUpdateGlobalSecondaryIndexBase({ secondaryIndexOptions, existingTableInfo, }) {
        try {
            const existingIndexNames = [];
            const staledIndexNames = [];
            const allIndexNames = [];
            const newSecondaryIndexOptions = [];
            const updateResults = [];
            if (existingTableInfo?.GlobalSecondaryIndexes?.length) {
                existingTableInfo?.GlobalSecondaryIndexes.forEach((indexInfo) => {
                    if (indexInfo.IndexName) {
                        existingIndexNames.push(indexInfo.IndexName);
                    }
                });
            }
            secondaryIndexOptions?.forEach((newIndexInfo) => {
                allIndexNames.push(newIndexInfo.indexName);
                const indexExists = existingIndexNames.includes(newIndexInfo.indexName);
                if (!indexExists) {
                    newSecondaryIndexOptions.push(newIndexInfo);
                }
            });
            existingIndexNames.forEach((indexName) => {
                const existsInList = allIndexNames.includes(indexName);
                if (!existsInList) {
                    staledIndexNames.push(indexName);
                }
            });
            if (!(newSecondaryIndexOptions.length || staledIndexNames.length)) {
                return null;
            }
            let canUpdate = false;
            const { tableFullName } = this._tbl_getLocalVariables();
            LoggingService.log({
                secondaryIndexOptions: secondaryIndexOptions.length,
                newSecondaryIndexOptions: newSecondaryIndexOptions.length,
                staledIndexNames: staledIndexNames.length,
                tableName: tableFullName,
            });
            if (newSecondaryIndexOptions.length) {
                canUpdate = true;
                let indexCount = 0;
                for (const indexOption of newSecondaryIndexOptions) {
                    const params = {
                        TableName: tableFullName,
                        GlobalSecondaryIndexUpdates: [],
                    };
                    indexCount++;
                    const creationParams = this._getGlobalSecondaryIndexCreationParams({
                        secondaryIndexOptions: [indexOption],
                    });
                    const indexName = creationParams.xGlobalSecondaryIndex[0].IndexName;
                    params.AttributeDefinitions = [...creationParams.xAttributeDefinitions];
                    creationParams.xGlobalSecondaryIndex.forEach((gsi) => {
                        params.GlobalSecondaryIndexUpdates?.push({
                            Create: {
                                ...gsi,
                            },
                        });
                    });
                    const result = await this._tbl_dynamoDb().updateTable(params);
                    if (result?.TableDescription) {
                        updateResults.push(result?.TableDescription);
                    }
                    LoggingService.log([
                        `Creating Index: '${indexName}'`,
                        `on table '${tableFullName}' started:`,
                        new Date().toTimeString(),
                    ].join(" "));
                    if (indexCount !== newSecondaryIndexOptions.length) {
                        await UtilService.waitUntilMunites(5);
                    }
                }
            }
            if (staledIndexNames.length) {
                if (canUpdate) {
                    await UtilService.waitUntilMunites(4);
                }
                canUpdate = true;
                let indexCount = 0;
                for (const indexName of staledIndexNames) {
                    const params = {
                        TableName: tableFullName,
                        GlobalSecondaryIndexUpdates: [],
                    };
                    indexCount++;
                    params.GlobalSecondaryIndexUpdates?.push({
                        Delete: {
                            IndexName: indexName,
                        },
                    });
                    const result = await this._tbl_dynamoDb().updateTable(params);
                    if (result?.TableDescription) {
                        updateResults.push(result?.TableDescription);
                    }
                    LoggingService.log([
                        `Deleting Index: '${indexName}'`,
                        `on table '${tableFullName}' started:`,
                        new Date().toTimeString(),
                    ].join(" "));
                    if (indexCount !== staledIndexNames.length) {
                        await UtilService.waitUntilMunites(1);
                    }
                }
            }
            if (!canUpdate) {
                return null;
            }
            if (updateResults.length) {
                LoggingService.log({
                    "@allCreateGlobalSecondaryIndexBase": "",
                    updateResults,
                });
                return updateResults;
            }
            return null;
        }
        catch (error) {
            LoggingService.log({
                "@allCreateGlobalSecondaryIndexBase": "",
                error: error?.message,
            });
            return null;
        }
    }
    async fuse_tbl_createTableIfNotExists() {
        const { secondaryIndexOptions } = this._tbl_getLocalVariables();
        const existingTableInfo = await this.fuse_tbl_getTableInfo();
        if (existingTableInfo) {
            if (secondaryIndexOptions?.length) {
                await this._allUpdateGlobalSecondaryIndexBase({
                    secondaryIndexOptions,
                    existingTableInfo,
                });
            }
            else if (existingTableInfo.GlobalSecondaryIndexes?.length) {
                await this._allUpdateGlobalSecondaryIndexBase({
                    secondaryIndexOptions: [],
                    existingTableInfo,
                });
            }
            return null;
        }
        return await this.fuse_tbl_createTable();
    }
    _getGlobalSecondaryIndexCreationParams({ secondaryIndexOptions, }) {
        const { tableFullName } = this._tbl_getLocalVariables();
        const params = {
            KeySchema: [],
            AttributeDefinitions: [],
            TableName: tableFullName,
            GlobalSecondaryIndexes: [],
        };
        const attributeDefinitionsNameList = [];
        secondaryIndexOptions.forEach((sIndex) => {
            const { indexName, partitionKeyFieldName: keyFieldName, sortKeyFieldName: sortFieldName, dataType, projectionFieldsInclude, } = sIndex;
            const _keyFieldName = keyFieldName;
            const _sortFieldName = sortFieldName;
            if (!attributeDefinitionsNameList.includes(_keyFieldName)) {
                attributeDefinitionsNameList.push(_keyFieldName);
                params?.AttributeDefinitions?.push({
                    AttributeName: _keyFieldName,
                    AttributeType: dataType,
                });
            }
            if (!attributeDefinitionsNameList.includes(_sortFieldName)) {
                attributeDefinitionsNameList.push(_sortFieldName);
                params?.AttributeDefinitions?.push({
                    AttributeName: _sortFieldName,
                    AttributeType: dataType,
                });
            }
            let projectionFields = (projectionFieldsInclude || []);
            let projectionType = "ALL";
            if (projectionFields?.length) {
                projectionFields = projectionFields.filter((field) => {
                    return field !== _keyFieldName && field !== _sortFieldName;
                });
                if (projectionFields.length === 0) {
                    projectionType = "KEYS_ONLY";
                }
                else {
                    projectionType = "INCLUDE";
                }
            }
            params.GlobalSecondaryIndexes?.push({
                IndexName: indexName,
                Projection: {
                    ProjectionType: projectionType,
                    NonKeyAttributes: projectionType === "INCLUDE" ? projectionFields : undefined,
                },
                KeySchema: [
                    {
                        AttributeName: _keyFieldName,
                        KeyType: "HASH",
                    },
                    {
                        AttributeName: _sortFieldName,
                        KeyType: "RANGE",
                    },
                ],
            });
        });
        return {
            xAttributeDefinitions: params.AttributeDefinitions || [],
            xGlobalSecondaryIndex: params.GlobalSecondaryIndexes || [],
        };
    }
    async fuse_tbl_createTable() {
        const { partitionKeyFieldName, sortKeyFieldName, tableFullName, secondaryIndexOptions, } = this._tbl_getLocalVariables();
        const params = {
            AttributeDefinitions: [
                {
                    AttributeName: partitionKeyFieldName,
                    AttributeType: "S",
                },
                {
                    AttributeName: sortKeyFieldName,
                    AttributeType: "S",
                },
            ],
            KeySchema: [
                {
                    AttributeName: partitionKeyFieldName,
                    KeyType: "HASH",
                },
                {
                    AttributeName: sortKeyFieldName,
                    KeyType: "RANGE",
                },
            ],
            BillingMode: "PAY_PER_REQUEST",
            TableName: tableFullName,
        };
        params.Tags = [
            {
                Key: "tablePrefix",
                Value: tableFullName,
            },
            {
                Key: `DDBTableGroupKey-${tableFullName}`,
                Value: tableFullName,
            },
        ];
        if (secondaryIndexOptions?.length) {
            const creationParams = this._getGlobalSecondaryIndexCreationParams({
                secondaryIndexOptions,
            });
            if (creationParams.xAttributeDefinitions?.length) {
                const existAttrDefNames = params.AttributeDefinitions?.map((def) => def.AttributeName);
                creationParams.xAttributeDefinitions.forEach((def) => {
                    const alreadyDefined = existAttrDefNames?.includes(def.AttributeName);
                    if (!alreadyDefined) {
                        params.AttributeDefinitions?.push(def);
                    }
                });
            }
            params.GlobalSecondaryIndexes = [...creationParams.xGlobalSecondaryIndex];
        }
        LoggingService.log({
            "@allCreateTableBase, table: ": tableFullName,
        });
        const result = await this._tbl_dynamoDb().createTable(params);
        if (result?.TableDescription) {
            LoggingService.log([
                `@allCreateTableBase,`,
                `Created table: '${result?.TableDescription.TableName}'`,
                new Date().toTimeString(),
            ].join(" "));
            return result.TableDescription?.TableName;
        }
        return null;
    }
    async fuse_tbl_deleteGlobalSecondaryIndex(indexName) {
        const { tableFullName } = this._tbl_getLocalVariables();
        const params = {
            TableName: tableFullName,
            GlobalSecondaryIndexUpdates: [
                {
                    Delete: {
                        IndexName: indexName,
                    },
                },
            ],
        };
        const result = await this._tbl_dynamoDb().updateTable(params);
        if (result?.TableDescription) {
            return result.TableDescription?.TableName;
        }
        return null;
    }
}
